<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
    <mat-card-title>Detalle Grupo Vacaciones</mat-card-title>
    </mat-card-header-->
    <mat-card-content>

        <form class="form-container" (ngSubmit)="onSubmitHolidays(holidaysForm)" #holidaysForm="ngForm" >

            <mat-card class="general-wf-card" appearance="outlined">
                <mat-card-header>
                    <mat-card-title>Datos Generales</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div id="container" class="formControl">
                            
                      <div class="control">
                          <mat-form-field class="imput-full-width">
                          <mat-label>Descripción de Grupo</mat-label>
                          <input type="text" matInput name="holidayGroup.description" [(ngModel)]="holidayGroup.description" >
                          </mat-form-field>
                      </div>

                      <div class="control"> 
                        <button mat-flat-button class="button buttonWidth" type="button" (click)="addList()">
                          Agregar Lista
                        </button>
                      </div>

                    </div>
                </mat-card-content>
            </mat-card>
            <br>

            <div *ngFor="let list of holidayGroup.holidayLists; let listIndex = index">
              <mat-card class="general-wf-card" appearance="outlined">
                <mat-card-header>
                  <div id="container" class="formControl">
                            
                    <div class="control">
                        <mat-form-field class="imput-full-width">
                        <mat-label>Descripción de lista</mat-label>
                        <input type="text" matInput name="list.description{{listIndex}}" [(ngModel)]="list.description" >
                        </mat-form-field>
                    </div>

                </div>
              </mat-card-header>
              <mat-card-content>
                <div style="margin-top: 1rem;">
                  <h4>Configuraciones de Vacaciones</h4>
                  <div class="control"> 
                    <button mat-flat-button class="button buttonWidth" type="button" (click)="addConfiguration(listIndex)">
                      Agregar registro
                    </button>
                  </div>
                  <div
                    *ngFor="let config of list.holidayConfigurations; let cIndex = index"
                    style="margin-bottom: 0.5rem;">
                    
                    <label>Años: </label>
                    <input
                      type="number"
                      name="initialYear{{listIndex}}_{{cIndex}}"
                      [(ngModel)]="config.initialYear"
                      style="width: 60px;" />
                  
                    <input
                      type="number"
                      name="finalYear{{listIndex}}_{{cIndex}}"
                      [(ngModel)]="config.finalYear"
                      style="width: 60px;" />
                  
                    <label>Días:</label>
                    <input
                      type="number"
                      name="vacationDays{{listIndex}}_{{cIndex}}"
                      [(ngModel)]="config.vacationDays"
                      style="width: 60px;" />
                  
                    <label>%:</label>
                    <input
                      type="number"
                      name="percentage{{listIndex}}_{{cIndex}}"
                      [(ngModel)]="config.percentage"
                      style="width: 60px;" />
                  </div>
                </div>

                <table class="table-div-area">
                  <thead>
                    <tr>
                      <th>División / Área</th>
                      <th *ngFor="let area of areas">{{ area.description }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let division of divisions; let rowIndex = index"
                        [class.hovered-row]="hoveredRow === rowIndex">
                      <td>{{ division.description }}</td>
                      <td *ngFor="let area of areas; let colIndex = index"
                          [class.hovered-col]="hoveredCol === colIndex"
                          (mouseenter)="onMouseEnter(rowIndex, colIndex)"
                          (mouseleave)="onMouseLeave()">
                        <input
                          type="checkbox"
                          [checked]="isSelected(listIndex, division.id, area.id)"
                          (change)="onCheckboxChange(listIndex, division, area, $event)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                </mat-card-content>
              </mat-card>
              <br>
            </div>
            
            <div class="formControl">
                <div class="control">
                  <button mat-flat-button class="button buttonWidth">
                    {{(holidayGroup.id > 0)? 'Actualizar': 'Guardar'}}
                  </button>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>
    